import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import "./Message_Send_Modal.css";
import Message_Send_Lottie from "../../need-help/message_send_lottie/Message_Send_Lottie.json";

const Message_Send_Modal = ({ showAccountModal, handleAccountModalClose }) => {
  return (
    <div className="Modal-wrapper">
      <Modal
        show={showAccountModal}
        onHide={handleAccountModalClose}
        centered
        className="account-created-modal"
      >
        <Modal.Body className="modal-body text-center p-0">
          <div className="lottie-container">
            <Lottie
              animationData={Message_Send_Lottie}
              loop={false}
              style={{ height: 200 }}
            />
          </div>

          <div className="account-text">
            <h3>Message Sent Successfully!</h3>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Message_Send_Modal;
